<template>
  <div>
    <HearderTitle name="查看详情" />
    <div class="main">
      <el-card shadow="always">
        <div slot="header" class="clearfix">
          <div style="width: 100px; height: 138px; background-color: #eee; margin-right: 34px"></div>
          <div class="info">
            <h3 style="margin-bottom: 28px">{{ personnelInfo.pername }}</h3>
            <div>
              <span>联系方式：</span>
              <span>{{ personnelInfo.contact }}</span>
            </div>
          </div>
          <div class="content" style="padding-right: 0">
            <ul>
              <li style="width: 50%">
                <span>应聘岗位</span><i>{{ personnelInfo.gangwei }}</i>
              </li>

              <li style="width: 50%">
                <span>学历</span><i>{{ personnelInfo.edu }}</i>
              </li>
              <li style="width: 50%">
                <span>联系方式</span><i>{{ personnelInfo.contact }}</i>
              </li>

              <!-- <li>
                <span>专业</span><i>{{ personnelInfo.manjor }}</i>
              </li> -->
              <li style="width: 50%">
                <span>应聘时间</span><i>{{ personnelInfo.ptime.split(' ')[0] }}</i>
              </li>
            </ul>
          </div>
        </div>
      </el-card>
      <el-card class="mt20 card2" shadow="always">
        <el-divider class="divider" content-position="left">面试信息</el-divider>
        <div class="info">
          <ul>
            <li>
              <span>性别</span><i>{{ personnelInfo.sex }}</i>
            </li>
            <li>
              <span>政治面貌</span><i>{{ personnelInfo.organ }}</i>
            </li>
            <li>
              <span>婚姻状态</span><i>{{ personnelInfo.marrage }}</i>
            </li>
            <li>
              <span>学校</span><i>{{ personnelInfo.school }}</i>
            </li>
            <li>
              <span>生日</span><i>{{ personnelInfo.birthday }}</i>
            </li>
            <li>
              <span>户籍</span><i>{{ personnelInfo.province }}</i>
            </li>
            <li>
              <span>户籍所在地</span><i>{{ personnelInfo.address }}</i>
            </li>
            <li>
              <span>面试人</span><i>{{ personnelInfo.msper }}</i>
            </li>
            <li>
              <span>邀约人</span><i>{{ personnelInfo.invitePeople }}</i>
            </li>
            <li>
              <span>面试评价</span><i>{{ personnelInfo.mspj }}</i>
            </li>
            <li>
              <span>备注</span><i>{{ personnelInfo.moreinfo }}</i>
            </li>
          </ul>
        </div>
        <el-divider class="divider" content-position="left">简历图片</el-divider>
        <div class="imgbox">
          <a v-for="item in picList" :key="item" target="_blank" :href="item"><img :src="item" alt="" /></a>
        </div>
        <div v-if="personnelInfo.isp == 5">
          <el-divider class="divider" content-position="left">黑名单</el-divider>
          <div class="info">
            <ul>
              <li>
                <span>操作人</span><i>{{ personnelInfo.operator }}</i>
              </li>
              <li>
                <span>转黑名单时间</span><i>{{ personnelInfo.blacklist_time }}</i>
              </li>
              <li>
                <span>黑名单时效</span><i>{{ blacklist_duration }}</i>
              </li>
              <li style="width: 50%; padding-left: 95px">
                <span>截止</span><i> {{ calculateEndDate(personnelInfo.blacklist_time, personnelInfo.blacklist_duration) }}</i>
              </li>
              <li>
                <span>黑名单原因</span><i>{{ personnelInfo.blacklist_reason }}</i>
              </li>
            </ul>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
  import { getAuditionInfoById } from '@/api/audition.js'
  import HearderTitle from '@/components/HearderTitle'

  export default {
    name: 'auditionlDetail',
    data() {
      return {
        personnelInfo: {},
      }
    },
    created() {
      let id = ''
      if (this.$route.params.id) {
        id = this.$route.params.id
        sessionStorage.setItem('personneId', id)
      } else {
        id = JSON.parse(sessionStorage.getItem('personneId'))
      }
      this.getAuditionInfoById(id)
    },
    methods: {
      // 根据id查询人员信息
      async getAuditionInfoById(id) {
        let res = await getAuditionInfoById({ id })
        this.personnelInfo = res.data
      },
      calculateEndDate(startDate, duration) {
        const date = new Date(startDate)
        switch (duration) {
          case 0:
            date.setMonth(date.getMonth() + 3)
            break
          case 1:
            date.setMonth(date.getMonth() + 6)
            break
          case 2:
            date.setFullYear(date.getFullYear() + 1)
            break
          case 3:
            date.setFullYear(date.getFullYear() + 2)
            break
          case 4:
            date.setFullYear(date.getFullYear() + 3)
            break
          default:
            return '未知时效'
        }
        return date.toISOString().split('T')[0]
      },
    },
    components: { HearderTitle },
    computed: {
      status: {
        get() {
          const arr = ['', '试岗期', '试用期', '正式员工']
          return arr[this.personnelInfo.stu]
        },
      },
      blacklist_duration: {
        get() {
          const arr = ['3个月', '6个月', '1年', '2年', '3年']
          return arr[this.personnelInfo.blacklist_duration]
        },
      },
      picList: {
        get() {
          if (!this.personnelInfo.pics) return []
          let arr = this.personnelInfo.pics.split(',').reverse()
          return arr
        },
      },
    },
  }
</script>

<style lang="less">
  .main {
    width: 1030px;
    margin: 0 auto;
    padding-top: 35px;
    .clearfix {
      display: flex;
      padding-top: 10px;
      padding-left: 20px;
      padding-bottom: 10px;
      align-items: center;

      img {
        margin-right: 24px;
      }
      .info {
        color: #333333;
        > div {
          height: 12px;
          font-size: 12px;
          line-height: 12px;
          display: flex;
          align-items: center;
          i {
            padding: 0 10px;
          }
        }
        h3 {
          font-size: 24px;
          font-weight: normal;
          margin-bottom: 10px;
        }
        span {
          font-size: 12px;
          &:last-child {
            color: #015293;
          }
        }
      }
    }
    .content {
      padding-left: 45px;
      padding-right: 45px;
      ul {
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 12px;
        color: #333333;
        li {
          span {
            margin-right: 10px;
          }
          i {
            color: #015293;
          }
        }
      }
    }
    .card2 {
      padding-left: 40px;
      margin-bottom: 30px;
      .divider {
        margin-bottom: 30px;
        font-size: 14px;
        .el-divider__text {
          line-height: 14px;
          height: 14px;
          padding: 1px 10px;
        }
        .is-left {
          left: 0;
          border-left: 3px solid #1f7ac3;
        }
      }
      .info {
        ul {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          li {
            width: 50%;
            text-align: left;
            font-size: 12px;
            color: #333333;
            margin-bottom: 20px;
            &:nth-child(2n + 1) {
              padding-left: 80px;
            }
            &:nth-child(2n) {
              padding-left: 95px;
            }
            &:nth-last-of-type(-n + 2) {
              width: 100%;
              text-align: left;
              padding-left: 80px;
            }
            span {
              margin-right: 18px;
              display: inline-block;
              width: 100px;
              text-align: right;
            }
            i {
              display: inline-block;
              width: 67%;
              text-align: left;
              color: #015293;
            }
          }
        }
      }
      .imgbox {
        padding-left: 100px;
        min-height: 48px;
        a {
          display: inline-block;
          width: 126px;

          margin-right: 30px;
          margin-bottom: 5px;
          height: 168px;
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
        }
      }
    }
  }
</style>
